"use client";

import { Printer } from "lucide-react";

// Drukt de pagina af; wat er op papier komt bepaalt [data-afdruk] in
// globals.css. Op een telefoon opent dit het deel- of afdrukmenu van het
// toestel, en daar zit ook "opslaan als pdf" - handig om door te sturen.
export function Afdrukknop({ label }: { label: string }) {
  return (
    <button
      type="button"
      onClick={() => window.print()}
      className="mx-auto flex items-center gap-2 rounded-full border border-border px-4 py-2 text-xs font-semibold text-soft-foreground transition-colors hover:border-primary hover:text-white print:hidden"
    >
      <Printer className="size-4" aria-hidden />
      {label}
    </button>
  );
}
